// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Details_subtitle__3CmRU"};